<template>
  <div v-if="field.options" class="radio-input">
    <label class="subtitle-2 black--text pl-3">
      {{ field.label }}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <div class="list mt-3">
      <div v-for="option in field.options" :key="option.id" class="input-group">
        <input
          @change="update()"
          :id="'radio-'+option.id"
          :value="option.value"
          v-model="model"
          type="radio"
        />
        <label :for="'radio-'+option.id">
          <template v-if="option.images.length>0">
            <v-row no-gutters>
              <v-col cols="4">
                <v-img
                  :src="$assets.url(option.images[0].file.previewUrl)"
                  width="50px"
                  height="50px"
                />
              </v-col>
              <v-col cols="8">
                {{ option.label }} {{ (option.upcharge && !field.config.hideUpcharge)?'( + ' + option.upcharge + ' CHF) ':'' }}
                <v-dialog v-model="imagesExemple[option.id]" fullscreen>
                  <template v-slot:activator="{on}">
                    <v-btn text v-on="on" x-small class="pl-0 pr-0">Voir les exemples</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-spacer />
                      <v-btn icon @click="imagesExemple[option.id]=false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-carousel hide-delimiters height="800px">
                      <v-carousel-item v-for="img in option.images" :key="img.id">
                        <v-img :src="$assets.url(img.file.url)" height="100%" />
                      </v-carousel-item>
                    </v-carousel>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
          <template
            v-else
          >{{ option.label }} {{ (option.upcharge && !field.config.hideUpcharge)?'( + ' + option.upcharge + ' CHF) ':'' }}</template>
        </label>
      </div>
    </div>
    <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
  </div>
</template>
<script>
import FieldMixin from "./FieldMixin";
export default {
  data: () => ({
    imagesExemple: {}
  }),
  mixins: [FieldMixin],
  name: "FieldRadio",
  methods: {
    validate: function() {
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-input {
  .list {
    display: flex;
    input {
      display: none;
      &:checked ~ label {
        background-color: #e76c2f;
        color: #fff;
      }
    }
    label {
      margin-right: 1rem;
      font-size: 0.8rem;
      padding: 0.5rem 1.2rem;
      background-color: #e8e8e8;
      transition: 0.5s;
      border-radius: 10px;
    }
  }
}
</style>
